var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcceptNotifIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42319 2.49998C6.42319 3.61938 5.54759 4.49996 4.50012 4.49996C3.45264 4.49996 2.57704 3.61938 2.57704 2.49998C2.57704 1.38058 3.45264 0.5 4.50012 0.5C5.54759 0.5 6.42319 1.38058 6.42319 2.49998ZM0.5 8.57144C0.5 7.91576 1.02159 7.32975 1.9135 6.87604C2.78219 6.43414 3.8297 6.21432 4.5 6.21432C5.1703 6.21432 6.21781 6.43414 7.0865 6.87604C7.97841 7.32975 8.5 7.91576 8.5 8.57144V9.19193C8.5 9.37691 8.35859 9.5 8.21678 9.5H0.783217C0.641412 9.5 0.5 9.37691 0.5 9.19193V8.57144Z",
    stroke: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptNotifIcon);
export default __webpack_public_path__ + "static/media/acceptNotifIcon.8b17969d9009c7ea66d999e93409d016.svg";
export { ForwardRef as ReactComponent };